var ezdia;
(function (ezdia) {
    var toggleTemplate = function (context) {
        var id = context.id;
        var ret = "<div id=\"" + id + "\" class=\"ez-nav-editor-tabs\">\n      <a href=\"javascript:void(0);\" class=\"active\"><i class=\"fa fa-edit\"></i> Editor</a>\n      <a href=\"javascript:void(0);\"><i class=\"fa fa-code\"></i> HTML</a>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.segments = {
            toggleTemplate: toggleTemplate
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
